import React from 'react'

export interface IPreloaderProps {
  width: string
  className?: string
}

const Preloader = ({ width, className = '' }: IPreloaderProps) => {
  return (
    <div className={'container-loader ' + className} style={{ width }}>
      <div className="item-loader" />
    </div>
  )
}

export default React.memo(Preloader)
